
export default class Video {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.video__player'), el => {
			new Video(el)
		});
	}

	constructor(el) {
		if (!el) return false;
		this.element = el;
		this.wrapper = this.element.parentNode;
		this.btn = new PlayerControl(this.wrapper.querySelector('.video__btn'));
		this.poster = new PlayerControl(this.wrapper.querySelector('.video__poster'));

		this.btn.getElement().addEventListener('click', () => {
			this.videoPlay();
		});

		this.element.addEventListener('ended', () => {
			this.videoStop();
		})
	}

	videoPlay() {
		this.element.play();
		this.btn.hide();
		this.poster.hide();
	}

	videoStop() {
		this.element.currentTime = 0;
		this.element.pause();
		this.btn.show();
		this.poster.show();
	}
}

class PlayerControl {
	constructor(el) {
		if (!el) return false;
		this.element = el;
	}

	getElement() {
		return this.element;
	}

	show() {
		this.element.classList.remove('hidden');
	}

	hide() {
		this.element.classList.add('hidden');
	}
}
